import {createRef} from "../createRef";

export default createRef({
    "id": "PAYDOC_TYPE_REF",
    "source": "PAYDOC_TYPE_REF",
    "fields": [
        {   "column": "id", },
        {   "column": "name", },
    ],
});
